// extracted by mini-css-extract-plugin
export default {"fallback":"RouteErrorBoundary_fallback__2KD-H"};